import {coupdoeilOnClickEvent} from "./events/onclick";
import {onMouseOver} from "./events/onmouseover";

import {clearPopoverContentCache} from "./popover/cache";
import {clearAll} from "./popover/closing";

document.addEventListener("DOMContentLoaded", () => {
  clearPopoverContentCache()
  document.addEventListener("click", coupdoeilOnClickEvent)
  document.documentElement.addEventListener("mouseover", onMouseOver, { passive: true })

  if (window.Turbo) {
    document.addEventListener('turbo:before-cache', (_event) => {
      clearAll()
    })
    document.addEventListener('turbo:load', (_event) => {
      clearAll()
      clearPopoverContentCache()
    })
  }
})
